/*******************************************************************************
 * Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                 is prohibited.
 *
 * Name          : ShippingAddress.tsx
 *
 * Project Title : Checkout
 *
 * Description   : Initial version
 *
 * Company       : Honeywell Technology Solutions , Hyderabad
 *
 * @Author       : H224423
 *
 * @Date         : Oct 21, 2019
 *
 * @Version      : Version 1.0
 *
 * By            : H224423
 * On            : Oct 21, 2019
 * Description   : ASDS-1548 changes.Added Modification History.
 *
 * By            : H422335
 * On            : Sep 07 2020
 * Description   : ASDS-2743 - Review Order UI Enhancements as part of APU Phase 2.
 *
*******************************************************************************/
import * as React from 'react';
import {
    Grid,
} from '@scuf/common';
import ShippingAddressInfo from './ShippingAddressInfo';
import ConfirmationEmail from './ConfirmationEmail';

// This function is used to display Shipping Address layout component
function ShippingAddress({addressDetails, emailAddressArr}) {
    return (
        <React.Fragment>
            <Grid.Row>
                <Grid.Column width={12} className="paddingbottom ">
                    <span className="ro-heading-text">Shipping Address</span>
                </Grid.Column>
            </Grid.Row>
            <Grid.Row>
                <Grid.Column width={11} className="paddingbottom">
                    <hr className="ro-hr-line" />
                </Grid.Column>
            </Grid.Row>
            <Grid.Row>
                <ShippingAddressInfo addressDetails={addressDetails}/>
                <ConfirmationEmail emailAddressArr={emailAddressArr}/>
            </Grid.Row>
        </React.Fragment>
    );
}

export default ShippingAddress;